import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { excluirFuncionario, cadastrarFuncionario, buscarFuncionariosDoEstabelecimento } from '../../services/api';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./FormCadastrarFuncionario.css";
import '../../styles/global.css';

const FormCadastrarFuncionario = () => {
    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));

    const [funcionarios, setFuncionarios] = useState([]);
    const [formData, setFormData] = useState({
        nomeCompleto: "",
        email: "",
        password: "",
        confirmPassword: "",
        idEstabelecimento: "",
        cpf: "",
        telefoneCelular: "",
        nomePerfil: "",
    });

    useEffect(() => {
        console.log('Verificando status do usuário na sessão...');
        if (userData) {
            try {
                if (userData.statusUsuario === 'logado') {
                    console.log('Dados do usuário na sessão:', userData);
                    const idEstabelecimento = userData.dadosEstabelecimento.id;

                    console.log('Dados do estabelecimento: ');
                    console.log(userData.dadosEstabelecimento);

                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        idEstabelecimento: idEstabelecimento
                    }));

                    fetchFuncionariosDoEstabelecimento();
                    console.log('id do estabelecimento: ', idEstabelecimento);
                } else {
                    console.log('Usuário não está logado, mantendo na área restrita.');
                }
            } catch (error) {
                console.error('Erro ao parsear os dados de usuário:', error);
            }
        } else {
            console.log('Usuário NÃO está logado!');
        }
    }, [navigate]);

    const fetchFuncionariosDoEstabelecimento = async () => {
        try {
            const dados = await buscarFuncionariosDoEstabelecimento(userData);
            if (dados?.funcionarios) {
                console.log('*** funcionarios ***', dados.funcionarios);
                setFuncionarios(dados.funcionarios);
            }
        } catch (error) {
            console.error('Erro ao buscar dados do estabelecimento:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        console.log('entrou no handleSubmit...');
        e.preventDefault();
        try {
            const response = await cadastrarFuncionario(formData);
            console.log('Funcionário cadastrado com sucesso:', response);
            alert('Funcionário cadastrado com sucesso!');
            fetchFuncionariosDoEstabelecimento(); // Atualiza a lista após cadastro
            navigate('/area-restrita');
        } catch (error) {
            console.error('Erro ao cadastrar funcionário:', error);
            const errorMessage = error.response?.data?.message || 'Erro ao cadastrar funcionário. Tente novamente.';
            alert(errorMessage);
        }
    };

    const handleExcluirFuncionario = async (funcionario) => {
        console.log('entrou no handleExcluirFuncionário...');
        try {
            const response = await excluirFuncionario(funcionario);
            console.log('Funcionário excluído com sucesso:', response);
            alert('Funcionário excluído com sucesso!');
            navigate('/area-restrita');
        } catch (error) {
            console.error('Erro ao excluir funcionário:', error);
            const errorMessage = error.response?.data?.message || 'Erro ao excluir funcionário. Tente novamente.';
            alert(errorMessage);
        }
    };

    return (
        <div className="form-cadastrar-container">
            <TituloComponent />
            <form onSubmit={handleSubmit}>
                <h2 className="form-title">Cadastro de Funcionário</h2>


                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
                    {/* Botão de Logout */}
                    {/* <button className="welcome-btn" onClick={handleLogout}>Logout</button> */}
                </div>



                <div className="form-section">
                    <h3 className="section-title">Dados Pessoais</h3>
                    <div className="form-group">
                        <label htmlFor="nomePerfil">Perfil</label>
                        <select
                            id="nomePerfil"
                            name="nomePerfil"
                            className="form-control"
                            value={formData.nomePerfil}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Selecione o perfil do Funcionário</option>
                            {["BAR COZINHA", "BAR GARCON", "BAR GERENTE", "BAR BARMAN"].map((perfil) => (
                                <option key={perfil} value={perfil}>
                                    {perfil}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="nomeCompleto">Nome completo</label>
                        <input
                            type="text"
                            id="nomeCompleto"
                            name="nomeCompleto"
                            className="form-control"
                            placeholder="Digite o nome completo"
                            value={formData.nomeCompleto}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="telefoneCelular">Telefone Celular com DDD</label>
                        <input
                            type="text"
                            id="telefoneCelular"
                            name="telefoneCelular"
                            className="form-control"
                            placeholder="Digite o telefone celular"
                            value={formData.telefoneCelular}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Digite o email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="cpf">CPF</label>
                        <input
                            type="tel"
                            id="cpf"
                            name="cpf"
                            className="form-control"
                            placeholder="Digite o CPF"
                            value={formData.cpf}
                            onChange={handleChange}
                            pattern="\d*"
                            maxLength="11"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Senha</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="form-control"
                            placeholder="Digite sua senha"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirme sua senha</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            className="form-control"
                            placeholder="Repita sua senha"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <button type="submit" className="btn-primary">
                    Cadastrar
                </button>
            </form>

            {/* Espaço entre o botão e a tabela */}
            <div className="mt-4"></div>

            {/* Tabela de Funcionários */}
            <div className="table-container">
                {/* <h3 className="section-title">Funcionários Cadastrados</h3> */}

                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Funcionários Cadastrados em {userData.dadosEstabelecimento.nome}</p>
                    {/* Botão de Logout */}
                    {/* <button className="welcome-btn" onClick={handleLogout}>Logout</button> */}
                </div>

                
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {funcionarios.length > 0 ? (
                            funcionarios.map((funcionario, index) => (
                                console.log('funcionário listado: '),
                                console.log(funcionario),

                                <tr key={index}>
                                    <td>{funcionario.dadosDeUsuario?.name || 'Não informado'}</td>
                                    <td>{funcionario.dadosDeUsuario?.email || 'Não informado'}</td>
                                    <td>Alterar</td>
                                    <td>
                                    <button
                                        onClick={() => {
                                            const confirmacao = window.confirm("Tem certeza que deseja excluir definitivamente este funcionário?");
                                            if (confirmacao) {
                                                handleExcluirFuncionario(funcionario);
                                            }
                                        }}
                                    >
                                            Excluir
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    Nenhum funcionário cadastrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FormCadastrarFuncionario;
